import axios from "axios";
import {url_local} from '../url'
//import state from "../../store";
import state from '../../store/index'


export function SubirAsignacion(form) {
    //console.log(state.state.currentUser.access_token);
    const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.post(`${url_local}asignacion`, form, config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej("error al subir la asignación: " + err);
        });
    });
    }

    export function QuitarAsignacion(form) {
        //console.log(state.state.currentUser.access_token);
        const config = {
            headers : {
                'Content-Type' : 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                Authorization: "Bearer " +state.state.currentUser.access_token
            }
        }
    
        return new Promise((res, rej) => {
            axios.post(`${url_local}deleteAsignacion`, form, config).then(response => {
                res(response.data);
            })
            .catch(err => {
                rej("error al quitar la asignación: " + err);
            });
        });
        }

        
     export function GetAsignacion() {
        //console.log(state.state.currentUser.access_token);
        const config = {
            headers : {
                'Content-Type' : 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                Authorization: "Bearer " +state.state.currentUser.access_token
            }
        }
    
        return new Promise((res, rej) => {
            axios.get(`${url_local}asignacion`, config).then(response => {
                res(response.data);
            })
            .catch(err => {
                rej("error al obtener la asignación: " + err);
            });
        });
        }

